export default "__VITE_ASSET__Dttkn3LV__"